module.exports = __webpack_public_path__ + "static/img/right-top-row-7.8e0cc80b.png";